export default {
  slug: "kotlin-multiplatform",
  code: "KM",
  label: "Kotlin Multiplatform",
  shortLabel: "Multiplatform",
  isKED: true,
  hasSubtitle: true,
  hasSubtitle2: true,
  logoFamily: "jb",
};
